import { KubaExportService } from './kuba-export.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { KubaExportComponent } from './kuba-export.component';

import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { AppSharedModule } from '../appShared.module';

@NgModule({
    imports: [TranslatePipe, TranslateDirective, AppSharedModule],
    exports: [KubaExportComponent],
    declarations: [KubaExportComponent],
    providers: [KubaExportService],
})
export class KubaExportModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: KubaExportModule
        };
    }
}
